import { render, staticRenderFns } from "./Ptspkabupaten.vue?vue&type=template&id=2cf01e04"
import script from "./Ptspkabupaten.vue?vue&type=script&lang=js"
export * from "./Ptspkabupaten.vue?vue&type=script&lang=js"
import style0 from "./Ptspkabupaten.vue?vue&type=style&index=0&id=2cf01e04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports